export default {"src":"/_next/static/media/stakeholderLogo.903ca4b1.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};